<t4-header icon="glyphicon-stats" title="{{'Turbo.Campaings.PartnerDashboard.Headline' | translate : 'Dashboard' }}">
</t4-header>

<t4-container [isLoading]="loading" title="Dashbord" style="margin-bottom:20px;">
  <mat-form-field appearance="fill">
    <mat-label>Campaign</mat-label>
    <mat-select (valueChange)="onCampaignChange($event)" [(ngModel)]="this.selectedCampaign">
      <mat-optgroup *ngFor="let group of campaignInfoGroups" [label]="group.status" class="campaign-group">
        <mat-option *ngFor="let campaign of group.campaignInfoList" [value]="campaign">
          {{ campaign.Title }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
    <div matSuffix style="margin-left:10px;">
      <mat-icon (click)="onClear($event)">clear</mat-icon>
    </div>
  </mat-form-field>
</t4-container>

<div class="row" style="margin-bottom:20px;">
  <div class="col-md-6">
    <dbwidget-campaign-overview [discountCode]="selectedCampaign?.DiscountCode" title="{{ 'TO.Turbo.Campaings.PartnerDashboard.DashbordHeadline_Activity' | translate : 'Activity overview'}}"></dbwidget-campaign-overview>
  </div>
  <div class="col-md-6">
    <t4-container *ngIf="selectedCampaign != null" title="Campaign: {{selectedCampaign?.Title}}">
      <div style="display:flex; margin-top:5px;">
        <div style="margin-right:15px;">
          <p style="font-weight:bold;"> Active between: </p>
          <p style="font-weight:bold;"> {{selectedCampaign?.ValidFrom | date: 'yyyy-MM-dd'}} - {{selectedCampaign?.ValidThrough | date: 'yyyy-MM-dd'}}</p>
        </div>
        <div style="margin-left:auto; margin-right:15px;">
          <p *ngIf="selectedCampaignData != null">Sent: {{selectedCampaignData[0].Sent}}</p>
          <p *ngIf="selectedCampaignData != null">Used: {{selectedCampaignData[0].Used}}</p>
        </div>
      </div>
    </t4-container>
  </div>
</div>

<t4-container>
  <mat-tab-group >
    <mat-tab label="Active">

      <t4-data-table #tblActive [allowFilter]="false" [rawData]="activeCampaignData" matSort matSortActive="FromDate" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['Title']">
        <ng-container matColumnDef="Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">Title</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{row.Title}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="FromDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">Valid from</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.FromDate | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ToDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">Valid to</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;"> {{row.ToDate | date : 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Sent">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">Sent</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Sent }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Used">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">Used</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Used }}</mat-cell>
        </ng-container>
      </t4-data-table>

    </mat-tab>
    <mat-tab  label="Archived">
      <t4-data-table #tblArchived [allowFilter]="false" [rawData]="archivedCampaignData" matSort matSortActive="FromDate" matSortDirection="desc" [autoGenerateColumns]="false" [filterFields]="['Title']">
        <ng-container matColumnDef="Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">Title</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{row.Title}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="FromDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">Valid from</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">{{ row.FromDate | date : 'yyyy-MM-dd' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="ToDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 150px;">Valid to</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;"> {{row.ToDate | date : 'yyyy-MM-dd'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Sent">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">Sent</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Sent }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Used">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">Used</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Used }}</mat-cell>
        </ng-container>
      </t4-data-table>
    </mat-tab>
  </mat-tab-group>
</t4-container>
